var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCin7BlueStacked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "729px",
    height: "596px",
    viewBox: "0 0 729 596",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cin7-blue-stacked") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cin7-blue-stacked",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cin7",
    transform: "translate(50.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.7187,316.8015 C131.3987,316.8015 157.0587,344.4345 162.9787,379.6805 L108.2777,379.6805 C105.1757,370.3765 97.2807,364.4545 85.7187,364.4545 C65.9817,364.4545 54.9847,382.2195 54.9847,406.1865 C54.9847,429.8725 65.9817,447.9185 85.7187,447.9185 C97.2807,447.9185 105.1757,441.9975 108.2777,432.4105 L162.9787,432.4105 C157.0587,467.9385 131.3987,495.5725 85.7187,495.5725 C35.2457,495.5725 -0.0003,458.0695 -0.0003,406.1865 C-0.0003,354.3035 35.2457,316.8015 85.7187,316.8015",
    id: "Fill-1",
    fill: "#002DFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#002DFF",
    points: "204.43 492.752 259.133 492.752 259.133 319.621 204.43 319.621"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#002DFF",
    points: "462.664 492.7522 417.83 492.7522 354.669 406.1862 354.669 492.7522 301.939 492.7522 301.939 319.6212 352.976 319.6212 409.935 400.2652 409.935 319.6212 462.664 319.6212"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#002DFF",
    points: "580.2471 492.7522 525.2631 492.7522 570.3781 366.1462 502.9871 366.1462 502.9871 319.6212 628.7461 319.6212 628.7461 354.8682"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#7F96FF",
    points: "268.7226 240.0022 292.7736 251.5842 299.7736 254.9552 262.9176 93.4982 235.2846 93.4982"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#7F96FF",
    points: "206.624 210.0974 237.675 225.0504 207.649 93.4984 180.011 93.4984"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#7F96FF",
    points: "335.5078 169.3845 318.1858 93.4985 290.5528 93.4985 321.6908 229.9235"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#002DFF",
    points: "368.2343 236.0476 341.3023 249.0166 392.8033 23.3746 411.4423 46.7376"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#002DFF",
    points: "422.122 210.0974 395.167 223.0774 430.081 70.1094 448.735 93.5014"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#002DFF",
    points: "254.5766 -0.0002 235.9356 23.3748 344.8606 23.3748 339.5256 46.7488 217.2946 46.7488 198.6546 70.1238 334.1906 70.1238 328.8556 93.4988 180.0106 93.4988 185.3456 116.8728 323.5206 116.8728 292.7736 251.5838 314.3716 261.9848 374.1696 -0.0002"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCin7BlueStacked);
export default __webpack_public_path__ + "static/media/cin7-blue-stacked.b9aee6eceebdb6f02172149cb7a43786.svg";
export { ForwardRef as ReactComponent };